export default __webpack_public_path__ + "static/media/avatar-placeholder.4029a128.svg";